<template>
  <div class="scl">
    <header class="scl__hero">
      <p class="scl__eyebrow">HAMWOORI / SERVICE AGREEMENT</p>
      <div class="scl__hero-row">
        <div>
          <h1 class="scl__title">계약서 목록</h1>
          <p class="scl__lead">어느 기관과 계약했는지 여기에 남습니다. 항목을 누르면 그 계약서를 이어서 수정합니다.</p>
        </div>
        <button type="button" class="scl__new" @click="emit('create')">새 계약서</button>
      </div>
    </header>

    <main class="scl__main">
      <p v-if="loading" class="scl__state">목록을 불러오는 중…</p>
      <p v-else-if="error" class="scl__state scl__state--error">
        {{ error }}
        <button type="button" class="scl__retry" @click="emit('refresh')">다시 시도</button>
      </p>
      <div v-else-if="!items.length" class="scl__empty">
        <img class="scl__empty-img" :src="illust.empty" alt="" />
        <p class="scl__empty-title">아직 저장된 계약서가 없습니다</p>
        <p class="scl__empty-text">새 계약서를 만들면 기관 이름과 함께 이 목록에 쌓입니다.</p>
        <button type="button" class="scl__new" @click="emit('create')">새 계약서</button>
      </div>
      <ul v-else class="scl__list">
        <li v-for="item in items" :key="item.id" class="scl__item">
          <button type="button" class="scl__open" @click="emit('open', item.id)">
            <span class="scl__org">{{ item.orgName || '기관명 없음' }}</span>
            <span class="scl__meta">
              <span v-if="item.facilityCode">기관기호 {{ item.facilityCode }}</span>
              <span v-if="item.representative">대표 {{ item.representative }}</span>
              <span v-if="item.legalName">{{ item.legalName }}</span>
            </span>
            <span class="scl__tags">
              <span class="scl__tag">임금 {{ selectLabel(item.wageSelect) }}</span>
              <span class="scl__tag">회계 {{ selectLabel(item.acctSelect) }}</span>
              <span class="scl__tag">별첨 2 {{ item.annex2Mode === 'text' ? '텍스트' : '양식' }}</span>
              <span class="scl__tag" :class="{ 'is-on': item.hasSign }">{{ item.hasSign ? '서명 있음' : '서명 없음' }}</span>
            </span>
            <span class="scl__when">수정 {{ formatWhen(item.updatedAt) }}</span>
          </button>
          <button type="button" class="scl__delete" @click="emit('remove', item)">삭제</button>
        </li>
      </ul>
    </main>
  </div>
</template>

<script setup lang="ts">
import { illust } from '@/constants/illust'
import type { ServiceContractListItem } from '@/api/serviceContract'

defineProps<{
  items: ServiceContractListItem[]
  loading: boolean
  error: string
}>()

const emit = defineEmits<{
  create: []
  open: [id: number]
  remove: [item: ServiceContractListItem]
  refresh: []
}>()

function selectLabel(value: string) {
  if (value === 'selected') return '선택'
  if (value === 'unselected') return '미선택'
  return '미정'
}

function formatWhen(value: string) {
  const text = String(value || '').replace('T', ' ')
  return text.slice(0, 16) || '—'
}
</script>

<style lang="scss" src="./ContractList.scss"></style>
